import "./Tabs.scss";
import { cn } from "tailwind-variants";

export default function Tabs({ slots = {}, children, ...restProps }) {
  return (
    <div {...restProps} className={cn("scope-513905da tabs", restProps.className)}>
      <div className="tabs__buttons scope-513905da" data-testid="tabs-buttons">
        {slots.buttons?.()}
      </div>
      <div className="tabs__body scope-513905da" data-testid="tabs-body">
        {children}
      </div>
    </div>
  );
}
